import React from "react";
import Form from "./Form";
import { Box } from "@mui/material";

const Index = ({ goalVideos, setGoalVideos, setDeletedVideos }) => {
  return (
    <Box style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      {goalVideos.map((data, index) => {
        return (
          <Form
            key={data.key_Id}
            data={data}
            index={index}
            setGoalVideos={setGoalVideos}
            setDeletedVideos={setDeletedVideos}
            goalVideos={goalVideos}
          />
        );
      })}
    </Box>
  );
};

export default Index;
